<template>
  <div class="immobile__gallery flex flex-wrap -mx-4">
    <div class="w-full px-8 md:px-4 mb-6">
      <VueSlickCarousel v-bind="settings" v-if="imgs.length">
        <div class="" v-for="(img, index) in imgs" :key="index">
          <img @click="() => showImg(index)" width="800" height="600" class="w-full cursor-pointer" v-bind:src="img"
               alt="">
        </div>
      </VueSlickCarousel>
    </div>
    <!-- all props & events -->
    <vue-easy-lightbox
        escDisabled
        moveDisabled
        :draggable="true"
        :visible="visible"
        :imgs="imgs"
        :index="index"
        @hide="handleHide"
    ></vue-easy-lightbox>
  </div>
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import VueEasyLightbox from 'vue-easy-lightbox'
/*import {fetchThumbnail} from "../http-commons";*/

export default {
  name: 'gallery',
  components: {
    VueSlickCarousel,
    VueEasyLightbox
  },
  data() {
    return {
      loading: false,
      visible: false,
      ids: null,
      imgs: [],
      index: 0,
      settings: {
        "dots": false,
        "dotsClass": "slick-dots custom-dot-class",
        "edgeFriction": 0.35,
        "infinite": false,
        "speed": 500,
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "draggable": true
      }
    }
  },
  props: {
    id: {},
    attachments: {},
    commons: {}
  },
  mounted() {
    this.init()
  },
  watch: {
    attachments: {
      deep: true,
      handler() {
        this.destroy()
        this.init()
      }
    }
  },
  methods: {
    init() {
      this.imgs = this.attachments.map(item => {
        return this.getImageSrc(item.IDPubblico)
      })
    },
    destroy() {
      this.imgs = []
    },
    getImageSrc($id) {
      return this.commons.attachmentSrc($id)
    },
    showImg(index) {
      this.index = index
      this.visible = true
    },
    handleHide() {
      this.visible = false
    }
  }
}
</script>
<style lang="scss">
.slick-arrow {
  &:before {
    color: black;
  }
}

.slick-slide {
  img {
    max-height: 500px;
    width: auto;
    margin: 0 auto;
  }
}

.vel-img-modal.vel-modal {
  background: white !important;
  .vel-img-wrapper {
    .vel-img {
      box-shadow: none !important;
    }
  }
  .vel-btns-wrapper {
    .btn__prev,
    .btn__next,
    .btn__close {
      color: black !important;
    }
  }
}
</style>
